import { Phone, Mail, MapPin, ArrowUp } from 'lucide-react';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Testimonials', href: '#testimonials' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Contact', href: '#contact' },
  ];

  const services = [
    'Kitchen Remodeling',
    'Bathroom Remodeling',
    'Full Home Renovations',
    'Garage Renovations',
    'Electrical & Interior',
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] border-t border-white/10">
      {/* Main Footer */}
      <div className="container-custom py-16 px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollToTop();
              }}
              className="inline-block mb-6"
            >
              <span className="font-serif text-3xl font-bold text-white">
                LUX
              </span>
              <span className="block text-xs text-[#D4AF37] tracking-[0.3em] uppercase mt-1">
                Renovations
              </span>
            </a>
            <p className="text-white/60 text-sm leading-relaxed mb-6">
              Premium home renovation services for homeowners in Gaithersburg and
              surrounding Maryland areas. Transform your space with expert
              craftsmanship.
            </p>
            <div className="flex gap-4">
              <a
                href="tel:2403709029"
                data-testid="footer-phone"
                className="w-10 h-10 bg-white/5 hover:bg-[#D4AF37] flex items-center justify-center transition-colors group"
              >
                <Phone className="w-4 h-4 text-white group-hover:text-[#0A0A0A]" />
              </a>
              <a
                href="mailto:info@luxrenovations.com"
                data-testid="footer-email"
                className="w-10 h-10 bg-white/5 hover:bg-[#D4AF37] flex items-center justify-center transition-colors group"
              >
                <Mail className="w-4 h-4 text-white group-hover:text-[#0A0A0A]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-lg text-white font-semibold mb-6">
              Quick Links
            </h4>
            <nav className="space-y-3">
              {quickLinks.map((link) => (
                <button
                  key={link.label}
                  onClick={() => scrollToSection(link.href)}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="block text-white/60 hover:text-[#D4AF37] transition-colors text-sm"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-lg text-white font-semibold mb-6">
              Our Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li
                  key={service}
                  className="text-white/60 text-sm flex items-center gap-2"
                >
                  <span className="w-1 h-1 bg-[#D4AF37] rounded-full" />
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-serif text-lg text-white font-semibold mb-6">
              Contact Us
            </h4>
            <div className="space-y-4">
              <a
                href="tel:2403709029"
                className="flex items-start gap-3 text-white/60 hover:text-[#D4AF37] transition-colors"
              >
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">(240) 370-9029</span>
              </a>
              <a
                href="mailto:info@luxrenovations.com"
                className="flex items-start gap-3 text-white/60 hover:text-[#D4AF37] transition-colors"
              >
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">info@luxrenovations.com</span>
              </a>
              <div className="flex items-start gap-3 text-white/60">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  Gaithersburg, MD
                  <br />& Surrounding Areas
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6 px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm text-center md:text-left">
            © {currentYear} Lux Renovations. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            data-testid="scroll-to-top"
            className="flex items-center gap-2 text-white/40 hover:text-[#D4AF37] transition-colors text-sm group"
          >
            Back to top
            <ArrowUp className="w-4 h-4 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
